import { Suspense } from "react";
import { Spin } from "antd";
import SignupContent from "@/components/signup/SignupContent";

/**
 * Signup Page
 * Multi-step registration flow
 *
 * Flow:
 * 1. Check if user is already registered
 * 2. If registered -> redirect to QR code page
 * 3. If not registered -> show 3-step signup:
 *    - Step 1: Policy acceptance
 *    - Step 2: Phone number input
 *    - Step 3: Verification code
 */
export default function SignupPage() {
  return (
    <Suspense
      fallback={
        <main className="flex min-h-screen items-center justify-center p-8">
          <div className="text-center">
            <Spin size="large" />
            <p className="mt-4 text-gray-600">Loading signup form...</p>
          </div>
        </main>
      }
    >
      <SignupContent />
    </Suspense>
  );
}
